module.exports = __webpack_public_path__ + "static/media/sms-inactive.61a77d2e.svg";